import { render } from "./layout4.vue?vue&type=template&id=22639488&scoped=true"
import script from "./layout4.vue?vue&type=script&lang=js"
export * from "./layout4.vue?vue&type=script&lang=js"

import "./layout4.vue?vue&type=style&index=0&id=22639488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22639488"]])

export default __exports__